export default __webpack_public_path__ + "static/media/Loan.9f79a36a.svg";